import { Method } from 'axios';

import { endpoints, methods, request } from '../../../../lib/api';

export const getBusinessReviewsRequest = async (businessId: string) => {
  return request(endpoints.businessReviews(businessId), methods.GET as Method);
};

export const addBusinessReviewRequest = async (businessId: string, accountId: string, review: any) => {
  return request(endpoints.businessReviews(businessId), methods.POST as Method, review, {
    'x-account-id': accountId,
  });
};

export const getReviewToken = async (businessId: string, reviewToken: string, accountId: string) => {
  return request(endpoints.reviewToken(businessId, reviewToken), methods.GET as Method, undefined, {
    'x-account-id': accountId,
  });
};

export const publishBusinessReviewRequest = async (businessId: string, reviewId: string) => {
  return request(endpoints.publishBusinessReviews(businessId, reviewId), methods.POST as Method, {});
};
